import { useEffect } from 'react';

/**
 * Scroll-reveal: observes all `.reveal` elements (including dynamically added
 * ones) and adds `.in-view` once they enter the viewport.
 */
export default function useReveal() {
  useEffect(() => {
    let io: IntersectionObserver | null = null;

    const observeAll = () => {
      if (!io) {
        io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('in-view');
                io?.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.12, rootMargin: '0px 0px -40px 0px' },
        );
      }
      document
        .querySelectorAll('.reveal:not(.in-view):not(.observed)')
        .forEach((el) => {
          el.classList.add('observed');
          io?.observe(el);
        });
    };

    observeAll();
    const mo = new MutationObserver(observeAll);
    mo.observe(document.body, { childList: true, subtree: true });

    return () => {
      mo.disconnect();
      io?.disconnect();
    };
  }, []);
}